import LeaderboardTableCell from './LeaderboardTableCell'
import Button from '@/components/Button'
import type { LeaderboardExtended } from '@/types/extended-types'

interface ILeaderboardTableProps {
  leaders: (LeaderboardExtended & { position: number; score: number })[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
}

const LeaderboardTable = ({ 
  leaders, 
  currentPage, 
  totalPages, 
  onPageChange 
}: ILeaderboardTableProps) => {
  return (
    <div className="w-full max-w-5xl mx-auto px-7">
      <div className="w-full rounded-[20px] bg-gradient-to-r from-book-100 to-book-300 flex flex-col shadow-md">
        {leaders.map((leader, index) => (
          <LeaderboardTableCell
            key={leader.id}
            position={leader.position}
            name={leader.expand?.user?.username || leader.fullName}
            institution="School"
            points={leader.score}
            isLast={index === leaders.length - 1}
          />
        ))}
      </div>
      
      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex justify-between items-center mt-4">
          <div className="w-1/3 flex justify-start">
            {currentPage > 1 && (
              <Button
                onClick={() => onPageChange(currentPage - 1)}
                variant="outline"
                className="font-black"
              >
                ←
              </Button>
            )}
          </div>
          <span className="w-1/3 text-center text-[24px] font-bold">
            {currentPage} / {totalPages}
          </span>
          <div className="w-1/3 flex justify-end">
            {currentPage < totalPages && (
              <Button
                onClick={() => onPageChange(currentPage + 1)}
                variant="outline"
                className="font-black"
              >
                →
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default LeaderboardTable